import React from 'react';
import { Box, Typography } from '@mui/material';

const Footer = () => (
  <Box
    sx={{
      position: 'fixed',
      bottom: 0,
      left: 0,
      right: 0,
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      fontSize: '14px',
      zIndex: 1000,
      backgroundColor: 'white',
      padding: '8px 20px',
    }}
  >
    <Box sx={{ display: 'flex', gap: 3 }}>
      <Typography variant="body2" sx={{ color: '#424242', fontWeight: 500 }}>
        HIPPO
      </Typography>
      <Typography
        variant="body2"
        component="a"
        href="https://www.nasa.gov/general/accessibility/"
        target="_blank"
        rel="noopener noreferrer"
        sx={{
          color: '#424242',
          textDecoration: 'underline',
          cursor: 'pointer',
        }}
      >
        Accessibility
      </Typography>
      <Typography
        variant="body2"
        component="a"
        href="https://www.nasa.gov/privacy/"
        target="_blank"
        rel="noopener noreferrer"
        sx={{
          color: '#424242',
          textDecoration: 'underline',
          cursor: 'pointer',
        }}
      >
        Privacy Policy
      </Typography>
    </Box>
    <Typography variant="body2" sx={{ color: '#424242' }}>
      2025 NASA. All rights reserved.
    </Typography>
  </Box>
);

export default Footer;
